import React from 'react';

const Footer = ({ onOpenLightbox, timerProgress, onTimerClick, environment }) => {
  // Calculate stroke dasharray for SVG circle (full = 60)
  const radius = 15;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(Math.max(timerProgress, 0), 60);
  const offset = circumference - (progress / 60) * circumference;

  return (
    <div className="footer-container">
      <div className="footer-title-section">
        <h1>AndonX React (beta)</h1>
        <span className="environment-indicator" style={{
          color: environment === 'production' ? '#28a745' : '#ffc107'
        }}>
          [{environment.toUpperCase()}]
        </span>
      </div>
      <div className="footer-icons">
        {/* Timer Icon - now clickable to open lightbox */}
        <button
          className="icon-button"
          onClick={() => onOpenLightbox('fetch-data')}
          title={`Auto-refresh in ${60 - progress}s - Click to fetch data`}
          style={{ position: 'relative', width: 35, height: 35, padding: 0, pointerEvents: 'auto', overflow: 'visible' }}
        >
          <svg width="35" height="35" viewBox="0 0 35 35" style={{ overflow: 'visible' }}>
            <circle
              cx="17.5"
              cy="17.5"
              r={radius}
              fill="transparent"
              stroke="#fff"
              strokeWidth="4"
              opacity="0.3"
            />
            <circle
              cx="17.5"
              cy="17.5"
              r={radius}
              fill="none"
              stroke="#fff"
              strokeWidth="4"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.5s linear' }}
            />
          </svg>
          <span style={{
            position: 'absolute',
            top: 0, left: 0, width: '100%', height: '100%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 12, color: '#fff', fontWeight: 700
          }}>{60 - progress}</span>
        </button>
      </div>
    </div>
  );
};

export default Footer;